'use strict';
import * as T from 'prop-types';

export const TaskType = {
  /** @type {TaskType} Project-level task. */
  PROJECT: 0,
  /** @type {TaskType} Project-Template-level task. */
  TEMPLATE: 1,
  /** @type {TaskType} Asset-Project-level task. */
  ASSET: 2,
};

export const isTaskType = T.oneOf(Object.values(TaskType));

/**
 * @typedef {Number} TaskType
 */



// WEBPACK FOOTER //
// ./src/js/tasks/enums/TaskType.js